export interface CheckoutTokenRequest {
  channelSourceData: {
    checkoutSourceRef: string;
  };
}
